/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const ReactTableCell = ({
  header,
  value,
  onMapUsingFilenameUpdate,
  row,
  activePermission,
}: any) => {
  switch (header) {
    case "retailer_name": {
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="text-gray-900 truncate w-full  inline-block">
              {value}
            </span>
          </TooltipTrigger>
          <TooltipContent>
            <TooltipArrow />
            <ul className="list-inside">{value}</ul>
          </TooltipContent>
        </Tooltip>
      );
    }
    case "divide_doc_to_chunks": {
      return (
        <span className="flex items-center gap-1 flex-wrap">
          {value ? "Yes" : "No"}
        </span>
      );
    }
    case "retailer_code": {
      return (
        <span>
          {value && value !== "" ? (
            <Badge variant={"outline"}>{value}</Badge>
          ) : (
            ""
          )}
        </span>
      );
    }
    case "settings": {
      return (
        <span className="grid grid-cols-[145px_155px_85px_149px_155px_192px_192px_139px] text-center gap-1 ">
          <div>{value?.delivery_date_settings?.days_after_order_date}</div>
          <div>
            {value?.delivery_date_settings?.is_equal_to_order_date
              ? "Yes"
              : "No"}
          </div>
          <div>{value?.delivery_date_settings?.today_date ? "Yes" : "No"}</div>

          <div>{value?.order_date_format}</div>
          <div>{value?.delivery_date_format}</div>
          <div>
            {value?.supported_document_types &&
            value?.supported_document_types?.length !== 0 ? (
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="text-gray-900 truncate w-full  py-1 text-center    px-3  rounded-[50px] inline-block">
                    {value?.supported_document_types.join(",")}
                  </span>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="w-full break-words">
                    {value?.supported_document_types.join(", ")}
                  </p>
                </TooltipContent>
              </Tooltip>
            ) : (
              ""
            )}
          </div>
          <div>
            {value?.ignore_keys && value?.ignore_keys?.length !== 0 ? (
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="text-gray-900 truncate w-full  py-1 text-center    px-3  rounded-[50px] inline-block">
                    {value?.ignore_keys.join(",")}
                  </span>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="w-full break-words">
                    {value?.ignore_keys.join(", ")}
                  </p>
                </TooltipContent>
              </Tooltip>
            ) : (
              ""
            )}
          </div>
          <div>{value?.branch_only_search ? "Yes" : "No"}</div>
        </span>
      );
    }
    case "matching_keys": {
      return (
        <span className="flex items-center gap-1 flex-wrap">
          {value.map((item: string, index: number) => {
            return (
              <Badge key={index} variant={"outline"}>
                {item}
              </Badge>
            );
          })}
        </span>
      );
    }
    case "map_using_filename": {
      return (
        <span className="flex items-center gap-1 flex-wrap">
          <Switch
            checked={value}
            disabled={activePermission?.update !== true}
            onCheckedChange={(prop) =>
              onMapUsingFilenameUpdate({ ...row, map_using_filename: prop })
            }
          />
        </span>
      );
    }
    case "auto_generate_reference_no": {
      return (
        <span className="flex items-center gap-1 flex-wrap">
          <Switch
            checked={value}
            disabled={activePermission?.update !== true}
            onCheckedChange={(prop) =>
              onMapUsingFilenameUpdate({
                ...row,
                auto_generate_reference_no: prop,
              })
            }
          />
        </span>
      );
    }
    default: {
      return <span>{value}</span>;
    }
  }
};
